import URIS from 'constants/uris';
import http from 'services/http';

export function logout() {
  return http.post(URIS.LOGOUT);
}
